import { useEffect } from 'react'
import { IntegrationConfig, IssueStatus, Resolution } from '../../api/shared'
import { usePopulateIntegration } from './use-populate-integration'

export interface UseUpdateFormWithPopulatedIntegrationParameters {
  issueTypeStatuses?: IssueStatus[]
  resolutions?: Resolution[]
  integration: IntegrationConfig
  update: (IntegrationConfig) => void
}
export const useUpdateFormWithPopulatedIntegration = ({
  integration,
  issueTypeStatuses,
  resolutions,
  update
}: UseUpdateFormWithPopulatedIntegrationParameters) => {
  const populatedIntegrationRow = usePopulateIntegration({
    issueTypeStatuses,
    resolutions,
    integration
  })

  useEffect(() => {
    if (
      typeof integration.issue_status === 'string' &&
      typeof populatedIntegrationRow?.issue_status !== 'string'
    ) {
      update(populatedIntegrationRow)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [populatedIntegrationRow, integration.issue_status])
}
